export const INBOX_TAB = "Inbox";
export const ARCHIVE_TAB = "Archive";
